import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

interface DocumentTitleProps {
  title: string
}

export const DocumentTitle = ({ title }: DocumentTitleProps) => {
  const { t } = useTranslation()

  useEffect(() => {
    document.title = title
      ? t('DOCUMENT_TITLE', { title })
      : t('DOCUMENT_TITLE_DEFAULT')
  }, [title, t])

  return null
}
